import { months } from './constants';

export const getMonthAndYear = date => {
  const arr = date.split('-');

  return `${months[arr[1]]} ${arr[0]}`;
};
